import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_portal-login_modal_enter_email-action_unknown';

/**
 * /login-modal/enter-email
Parameter could be one of these
1. A known email with PW login "PASSWORD"
2. A known email with SSO Login "SSO"
3. An Unknown Email "UNKNOWN"
4. Not Email "NOT_EMAIL"
5. A Faire email (optional) "ADMIN"
 */
export function trackRetailerPortalLoginModalEnterEmail(
  emailType: string = ''
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { emailType },
  });
}
